import { Typography } from "@mui/material";
import React from "react";
import "./TableHeader.css";
import { useDispatch, useSelector } from "react-redux";
import { SearchItems } from "../../../Redux/Action";
import SearchIcon from '@mui/icons-material/Search';

function TableHeader() {
  const SearchItem = useSelector((state) => state.SearchItems);
  const selectedAnalytics = useSelector((state)=>state.selectedAnalytics);
  const dispatch = useDispatch();

  const HandleChange = (e) => {
    dispatch(SearchItems(e.target.value.toUpperCase()));
    dispatch({ type: "SET_PAGE", payload: 0 });
  };

  const clearSearchField = () => {

  };

  return (
    <div className="TableHeader-container">
      <Typography
        variant="h5"
        component="h2"
        sx={{ fontSize: "20px", fontWeight: "bold", color: "#333333" }}
      >
        {selectedAnalytics === 'eod-analytics' ? "EOD Analytics Report" : "Intraday Analytics Report"}
      </Typography>
      <input
        id="outlined-basic"
        variant="outlined"
        placeholder="search stocks"
        className="input-form"
        onChange={HandleChange}
      />
      {/* <button onClick={clearSearchField} className="clear-button">
        Clear
      </button> */}
    </div>
  );
}

export default TableHeader;
